import { Box, Link } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { AppConfigFields, ContactInfoFields } from "../types/appConfigEntities";
import { LG } from "../styles/liquidGlass";

interface WhatsAppButtonProps {
  phoneNumber?: string;
}

export default function WhatsAppButton({ phoneNumber }: WhatsAppButtonProps) {
  const contactInfo = window.APP_CONFIG?.[AppConfigFields.ContactData];
  const whatsappMessage =
    contactInfo?.[ContactInfoFields.WhatsappMessage] || "Hola, quiero solicitar información.";
  const phone = (contactInfo?.[ContactInfoFields.Whatsapp] || phoneNumber || "").replace(/\D/g, "");
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: "none" }}>
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          width: 48,
          height: 48,
          borderRadius: LG.radius.pill,
          background: LG.color.buttonDark,
          backdropFilter: LG.blur,
          WebkitBackdropFilter: LG.blur,
          border: `1px solid ${LG.color.border}`,
          boxShadow: LG.shadow.lg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1500,
          transition: LG.transition,
          cursor: "pointer",
          "&:hover": {
            transform: "scale(1.08)",
            boxShadow: LG.shadow.xl,
          },
        }}
      >
        <WhatsApp sx={{ fontSize: 22, color: LG.color.buttonDarkText }} />
      </Box>
    </Link>
  );
}
